import { useColorCollectionReferences } from "./useColorCollectionReferences";

export const useColorCollectionReferencesCount = (
  colorCollectionId: string
) => {
  const { data: colorCollectionReferences } =
    useColorCollectionReferences(colorCollectionId);

  const totalDesignMappings =
    colorCollectionReferences?.mapping_list?.length || 0;

  const totalInputFormats = colorCollectionReferences?.format_list?.length || 0;

  return {
    total: totalDesignMappings + totalInputFormats,
  };
};
